<script>
export default {
  props: {
    data: Object
  },
  methods: {
    close(val) {
      this.$emit('close', val)
    }
  }
}
</script>
